import React, { Component } from 'react';
import { HeaderBlock } from "../../components/header-block/HeaderBlock";
import { Grid, Paper, Box } from "@material-ui/core";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import styles from "./HomePage.module.scss";
import { CustomCardContent } from "../../components/card-content/CardContent";
import { getToken } from "../../config/azureConfig";
import { getIcon } from "../../icon/icon";
import PageContainer from "../../components/page-container/PageContainer";
import { withTranslation } from 'react-i18next';

class HomePage extends Component {

  getContentGrid() {
    const { t } = this.props;

    const pages = [
      {
        name: t("route.routes"),
        path: "/routes",
        description: t("home.manage-routes"),
        icon: getIcon("seo-consulting.svg")
      },
      {
        name: t("user.users"),
        path: "/users",
        description:
          t("home.manage-users"),
        icon: getIcon("users.svg")
      }
    ];

    return (
      <div className={styles.contentGrid}>
        <BreadcrumbsItem to="/">{t("home.home")}</BreadcrumbsItem>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className={styles.cardContainer}>
              <CustomCardContent>
                <h3>{t("home.welcome")}</h3>
              </CustomCardContent>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <h2>{t("common.pages")}</h2>
          </Grid>
          {pages.map(page => {
            return (
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Paper className={styles.cardContainer}>
                  <div
                    onClick={() => this.props.history.push(page.path)}
                    className={styles.card}
                  >
                    <div className={styles.cardImage}>
                      {page.icon}
                    </div>
                    <div>
                      <div className={styles.cardTitle}>
                        {page.name}
                      </div>
                      <div className={styles.cardDescription}>
                        {page.description}
                      </div>
                    </div>
                  </div>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }

  render() {
    const { t } = this.props;

    return (
      <Box>
        <HeaderBlock title={t("home.home")} />
        <PageContainer>
          {this.getContentGrid()}
        </PageContainer>
      </Box>
    );
  }
}

export default withTranslation()(HomePage);
